<app-tooltip *ngIf="hasIcon" [text]="tooltipText">
  <img
    class="status-badge-icon"
    [src]="iconSrc"
    [style.width.px]="iconWidthPx"
    [style.height.px]="iconWidthPx"
    [attr.alt]="tooltipText ? tooltipText + ' status icon' : 'Status icon'"
  >
</app-tooltip>
